import { render, staticRenderFns } from "./RadioQuestion.vue?vue&type=template&id=19680438&scoped=true"
import script from "./RadioQuestion.vue?vue&type=script&lang=js"
export * from "./RadioQuestion.vue?vue&type=script&lang=js"
import style0 from "./RadioQuestion.vue?vue&type=style&index=0&id=19680438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19680438",
  null
  
)

export default component.exports